import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/FavouriteProfile.css";
import { profile1, profile2 } from "../../Constant";
import { connect } from "react-redux";
import { GetFavoritesAction } from "../../redux/actions/favorites";
import { Link } from "react-router-dom";
import config from "../../config";

const FavouriteProfile = ({ favorites, getFavorites }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFavorites().then(() => {
            console.log(favorites);
            setLoading(false);
        });
    }, []);

    return (
        <>
            <Header />
            {/* <!-- favourite profile sec Start Here --> */}
            <section className="all_favourite_profiles">
                <div className="container">
                    <div className="heading_wrapper">
                        <h4>Favourite Profiles</h4>
                        <p>
                            Out of mind, but never out of sight again. We keep
                            all your favorite caregivers and home-helpers in one
                            place.
                        </p>
                    </div>
                    <div className="all_profiles">
                        <div className="row">
                            {favorites.map((favorite) => (
                                <div className="col-lg-6">
                                    <Link to={`/single-profile/${favorite.id}`}>
                                        <div className="profile_box">
                                            <div className="img_box">
                                                <figure>
                                                    <img
                                                        src={config.returnImage(
                                                            favorite
                                                        )}
                                                        alt=""
                                                    />
                                                </figure>
                                            </div>
                                            <div className="contentDv">
                                                <div className="header-bar">
                                                    <h4>
                                                        {favorite.full_name}
                                                    </h4>
                                                    <p className="rating">
                                                        <i
                                                            className="fa fa-star"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        {
                                                            favorite.rating_by_customer
                                                        }
                                                    </p>
                                                    <p className="reviews">
                                                        <span className="reviews_count">
                                                            {
                                                                favorite.total_reviews
                                                            }
                                                        </span>{" "}
                                                        Reviews
                                                    </p>
                                                </div>
                                                <div className="address">
                                                    <span>
                                                        {favorite.city ||
                                                            "" +
                                                                favorite.state_name ||
                                                            "" + favorite.zip ||
                                                            ""}
                                                    </span>
                                                </div>
                                                <div className="about_caregiver">
                                                    <p>{favorite.bio}</p>
                                                </div>
                                                <div className="bottom_bar">
                                                    <div className="priceDv">
                                                        <h4>
                                                            $
                                                            <span>
                                                                {
                                                                    favorite
                                                                        .services[0]
                                                                        .per_hour
                                                                }
                                                            </span>
                                                            <sub>/Hour</sub>
                                                        </h4>
                                                    </div>
                                                    {/* <div className="availability not_available">
                                                        <p>
                                                            <i
                                                                className="fa fa-check-circle"
                                                                aria-hidden="true"
                                                            ></i>
                                                            Calendar Updated{" "}
                                                            <a href="#">
                                                                Check
                                                                Availability
                                                            </a>
                                                        </p>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="favourite_btn">
                                                <label className="container">
                                                    <input
                                                        type="checkbox"
                                                        checked="checked"
                                                    />
                                                    <span className="checkmark">
                                                        <i
                                                            className="fa fa-heart"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                        {/* <div className="all_results">
                            <div className="showing_results">
                                <p>Showing 5 of 102 </p>
                            </div>
                            <ul className="paginations">
                                <li className="prev arrows">Prev</li>
                                <div className="pagi_count">
                                    <li className="pagi active">1</li>
                                    <li className="pagi">2</li>
                                    <li className="pagi">3</li>
                                    <li className="pagi">4</li>
                                </div>
                                <li className="next arrows">Next</li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </section>
            {/* <!-- favourite profile sec End Here --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    favorites: state.favorites,
});

const mapDispatchToProps = (dispatch) => ({
    getFavorites: async () => dispatch(await GetFavoritesAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteProfile);
